export default function ListedAgo({ publishedAt, small = false, testId }) {
  const cls = small ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={testId || "listed-ago"}
      className={`inline-flex items-center rounded-full font-mono font-semibold tracking-wide bg-white/10 text-neutral-300 border border-white/10 ${cls}`}
    >
      {ago(publishedAt)}
    </span>
  );
}

function ago(publishedAt) {
  if (!publishedAt) return "Listed recently";
  const d = Math.floor((Date.now() - new Date(publishedAt).getTime()) / 86400000);
  if (d <= 0) return "Listed today";
  if (d === 1) return "Listed 1d ago";
  if (d < 7) return `Listed ${d}d ago`;
  if (d < 35) return `Listed ${Math.floor(d / 7)}w ago`;
  return `Listed ${Math.floor(d / 30)}mo ago`;
}
